import { Component, Input, Output, EventEmitter, Renderer2 } from '@angular/core';
import * as _ from 'lodash';
import { SharedService } from 'app/shared/services/shared.service';

@Component({
  selector: 'slider-component',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss'],
})
export class SliderComponent {
  @Input() public points: Array<any>;
  @Input() public selectedPoint: number;
  @Input() public disabled: boolean;
  @Input() public showValues: boolean;
  public pressed: boolean;
  public xPoints: Array<number>;
  public mouseX: number;
  public mouseMoveListener: any;
  public mouseUpListener: any;
  @Output() public onChange: EventEmitter<number>;

  constructor(public renderer: Renderer2, public sharedService: SharedService) {
    this.points = [
      { name: 'Min', value: 1 },
      { name: '', value: 2 },
      { name: '', value: 3 },
      { name: '', value: 4 },
      { name: 'Max', value: 5 },
    ];
    this.selectedPoint = 2;
    this.showValues = false;
    this.pressed = false;
    this.xPoints = [0];
    this.mouseX = 0;
    this.onChange = new EventEmitter<number>();
  }

  ngOnInit() {
    this.resetPoints();
  }

  ngOnChanges() {
    this.resetPoints();
  }

  resetPoints() {
    const xPoints: Array<number> = [];
    const slider: HTMLDivElement = <HTMLDivElement>document.getElementsByClassName('slider')[0];
    const xSpaceBetween = slider.offsetWidth / (this.points.length - 1);
    for (let i = 0; i < this.points.length; i++) {
      if (!_.isObject(this.points[i])) {
        this.points[i] = {
          name: this.points[i],
          value: this.points[i],
        };
      }
      if (i < this.points.length) {
        const xPositionValue = i * xSpaceBetween;
        xPoints.push(xPositionValue);
      }
    }
    xPoints.push(slider.offsetWidth);
    this.xPoints = xPoints;
  }
  getStopPointX() {
    const firstStopPoint = <HTMLDivElement>document.getElementsByClassName('stopPoint')[0];
    let circleSize = 0;
    if (firstStopPoint) {
      const slider: HTMLDivElement = <HTMLDivElement>document.getElementsByClassName('slider')[0];
      const spaceBetweenValue: number = slider.offsetWidth / (this.points.length - 1);
      circleSize = firstStopPoint.offsetWidth;
      return spaceBetweenValue - circleSize;
    } else {
      return null;
    }
  }

  getMarginLeftOfPointLabel(point: any) {
    const slider: HTMLDivElement = <HTMLDivElement>document.getElementsByClassName('slider')[0];
    const spaceBetweenValue: number = slider.offsetWidth / (this.points.length - 1);
    const pointNum = this.points.indexOf(point);
    const labelsContainer: HTMLDivElement = <HTMLDivElement>document.getElementsByClassName('pointLabelContainer')[0];
    let previousElement = null;
    let previousElementSize = 0;
    if (pointNum > 0) {
      previousElement = <HTMLSpanElement>labelsContainer.getElementsByClassName('pointLabel')[pointNum - 1];
      previousElementSize = pointNum > 0 ? previousElement.offsetWidth : 0;
    }
    return pointNum == 0 ? 0 : spaceBetweenValue - previousElementSize;
  }

  getTrackerX() {
    const slider: HTMLDivElement = <HTMLDivElement>document.getElementsByClassName('sliderStrip')[0];
    const mouseX: number = this.mouseX - slider.getClientRects()[0].left;
    return this.pressed ? Math.min(slider.clientWidth, Math.max(0, mouseX)) : this.xPoints[this.selectedPoint - 1];
  }

  goToPoint(pointNum: number) {
    this.selectedPoint = pointNum;
    this.onChange.emit(this.selectedPoint);
  }

  updateSliderValue($event: any) {
    const slider: HTMLDivElement = <HTMLDivElement>document.getElementsByClassName('sliderStrip')[0];
    const mouseX: number = this.sharedService.getMouseCoords($event, 'x');
    const deltas: Array<number> = [];
    let sorted: Array<number> = [];
    let currDelta: number;
    if (this.pressed) {
      for (let i = 0; i < this.xPoints.length; i++) {
        currDelta = Math.abs(this.xPoints[i] - (mouseX - slider.getClientRects()[0].left));
        deltas.push(currDelta);
        sorted.push(currDelta);
      }
      sorted = _.orderBy(sorted);
      this.goToPoint(deltas.indexOf(sorted[0]) + 1);
    }
  }

  onMouseDown($event: any) {
    const moveEvent: string = !this.sharedService.isMobile() ? 'mousemove' : 'touchmove';
    const upEvent: string = !this.sharedService.isMobile() ? 'mouseup' : 'touchend';
    this.pressed = true;
    this.onMouseMove($event);
    this.mouseMoveListener = this.renderer.listen(document, moveEvent, ($event: any) => {
      this.onMouseMove($event);
    });
    this.mouseUpListener = this.renderer.listen(document, upEvent, ($event: any) => {
      this.onMouseUp($event);
    });
  }

  onMouseMove($event: any) {
    this.mouseX = this.sharedService.getMouseCoords($event, 'x');
    if (this.pressed) {
      this.updateSliderValue($event);
    }
  }

  onMouseUp($event: any) {
    this.updateSliderValue($event);
    this.pressed = false;
    this.mouseMoveListener();
    this.mouseUpListener();
  }
}
